<template>
  <div>
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item>首页</a-breadcrumb-item>
      <a-breadcrumb-item>企业管理</a-breadcrumb-item>
      <a-breadcrumb-item>ACE</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="main-body">
      <a-tabs :animated="false" :activeKey="activeKey" @change="changeTab">

        <!-- <a-tab-pane key="2">
          <span slot="tab">预算管理</span>
          <fiscal v-if="activeKey === '2'"/>
        </a-tab-pane> -->

        <a-tab-pane key="1" v-if="false">
          <span slot="tab">SHOOT</span>
          <shootGrid v-if="activeKey === '1'"/>
        </a-tab-pane>

        <a-tab-pane key="6" v-if="false">
          <span slot="tab">SHORT</span>
          <shortGrid v-if="activeKey === '6'"/>
        </a-tab-pane>

        <a-tab-pane key="101" :v-if="showOpt">
          <span slot="tab">ACE</span>          
          <biliGrid v-if="activeKey === '101'"/>
        </a-tab-pane>

        <a-tab-pane key="201" v-if="false">
          <span slot="tab">BREAK</span>
          <breakListGrid v-if="activeKey === '201'"/>
        </a-tab-pane>

        <a-tab-pane key="88" v-if="false">
          <span slot="tab">TIME</span>
          <timeGrid v-if="activeKey === '88'"/>
        </a-tab-pane>

        <a-tab-pane key="199" v-if="false">
          <span slot="tab">SHAPE</span>
          <shapeGrid v-if="activeKey === '199'"/>
        </a-tab-pane>

        <a-tab-pane key="200" v-if="false">
          <span slot="tab">SHAPE LIST</span>
          <shapeListGrid v-if="activeKey === '200'"/>
        </a-tab-pane>
        
        <a-tab-pane key="4">
          <span slot="tab">KICK</span>
          <kickGrid v-if="activeKey === '4'"/>
        </a-tab-pane>
        

        <a-tab-pane key="3" v-if="false">
          <span slot="tab">ZORO</span>
          <zoroGrid v-if="activeKey === '3'"/>
        </a-tab-pane>

        <!-- <a-tab-pane key="688">
          <span slot="tab">RSI</span>
          <rsiGrid v-if="activeKey === '688'"/>
        </a-tab-pane> -->
        
        <!-- <a-tab-pane key="88">
          <span slot="tab">M5</span>
          <m5Grid v-if="activeKey === '88'"/>
        </a-tab-pane> -->

        <a-tab-pane key="10" v-if="false">
          <span slot="tab">His</span>
          <hisGrid v-if="activeKey === '10'"/>
        </a-tab-pane>

        <a-tab-pane key="18" v-if="false">
          <span slot="tab">MAIN</span>
          <mainChart v-if="activeKey === '18'"/>
        </a-tab-pane>

        <a-tab-pane key="12" v-if="false">
          <span slot="tab">Sort</span>
          <sortGrid v-if="activeKey === '12'"/>
        </a-tab-pane>

        <a-tab-pane key="5" v-if="false">
          <span slot="tab">BK</span>
          <bkGrid v-if="activeKey === '5'"/>
        </a-tab-pane>

        <a-tab-pane key="8" v-if="false">
          <span slot="tab">STOCK</span>
          <stockDetail v-if="activeKey === '8'"/>
        </a-tab-pane>

        <a-tab-pane key="9" v-if="false">
          <span slot="tab">Y30</span>
          <stockY30 v-if="activeKey === '9'"/>
        </a-tab-pane>

        <a-tab-pane key="100" v-if="false">
          <span slot="tab">X10</span>
          <stockX10 v-if="activeKey === '100'"/>
        </a-tab-pane>

      </a-tabs>
    </div>
  </div>
</template>

<script>
import fiscal from './fiscal'
import stockGrid from './stockGrid'
import shootGrid from './shootGrid'
import openGrid from './openGrid'
import kickGrid from './kickGrid'
import zoroGrid from './zoroGrid'
import hisGrid from './hisGrid'
import m5Grid from './m5Grid'
import sortGrid from './sortGrid'
import bkGrid from './bkGrid'
import rsiGrid from './rsiGrid'
import shortGrid from './shortGrid'
import timeGrid from './timeGrid'
import shapeGrid from './shapeGrid'
import shapeListGrid from './shapeListGrid'
import breakListGrid from './breakListGrid'
import stockDetail from './stockDetail'
import mainChart from './mainChart'
import stockY30 from './stockY30.vue'
import stockX10 from './stockX10.vue'
import biliGrid from './biliGrid.vue'

export default {
  name: 'index',
  components: {
    fiscal,
    hisGrid,
    rsiGrid,
    sortGrid,
    stockGrid,
    shootGrid,
    openGrid,
    zoroGrid,
    kickGrid,
    m5Grid,
    stockX10,
    mainChart,
    shortGrid,
    timeGrid,
    shapeGrid,
    shapeListGrid,
    breakListGrid,
    bkGrid,
    stockY30,
    stockDetail,
    biliGrid
  },
  created () {
    if(this.$ls.get('employee_id')=='42476' || this.$ls.get('employee_id')=='100071'){
      this.showOpt = true
    }
  },
  data() {
    return {
      activeKey: '101',
      showOpt: false,
    }
  },
  methods: {
    changeTab(key) {
      this.activeKey = key
    }
  }
}
</script>
